import { useState, type ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { createQueryClient } from './api/queryClient'
import { ErrorBoundary } from './components/ErrorBoundary'
import { ToastProvider } from './components/ui/Toast'
import { router } from './routes'
import { useSessionBootstrap, useSessionLostHandler } from './features/auth/useAuth'

/* Providers, then the router. The order matters: the session bootstrap needs
   the query client, and every route needs both. */

export function App(): ReactNode {
  const [queryClient] = useState(createQueryClient)

  return (
    <ErrorBoundary where="app-root">
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <SessionGate>
            <RouterProvider router={router} />
          </SessionGate>
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

/* Restores the session from the httpOnly refresh cookie before the router
   renders anything that depends on it. Kept as a child component so its hooks
   sit inside QueryClientProvider. */
function SessionGate({ children }: { children: ReactNode }): ReactNode {
  useSessionBootstrap()
  useSessionLostHandler()
  return <>{children}</>
}
